// src/helpers/pwa.ts
import { isNative, getPlatform } from '../platform';

export function checkStandalone(): boolean {
  if (isNative()) return true;
  if (typeof window === "undefined") return false;

  const displayModeStandalone =
    window.matchMedia?.("(display-mode: standalone)").matches ?? false;

  const iosStandalone = typeof navigator !== "undefined"
    ? (navigator as any)?.standalone === true
    : false;

  return displayModeStandalone || iosStandalone;
}

// Extended (and correct) device/platform detection
export function detectPlatform() {
  if (isNative()) {
    const p = getPlatform();
    return {
      isIos: p === 'ios',
      isAndroid: p === 'android',
      isFirefox: false,
      isDesktop: false,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    };
  }

  if (typeof navigator === "undefined") {
    return {
      isIos: false,
      isAndroid: false,
      isFirefox: false,
      isDesktop: false,
      userAgent: "",
    };
  }

  const ua = navigator.userAgent.toLowerCase();

  const isProbablyIosDevice = /iphone|ipad|ipod/.test(ua) ||
    (/macintosh/.test(ua) && "ontouchend" in window);

  const isIos = isProbablyIosDevice;

  const isAndroid = /android/.test(ua);
  const isFirefox = /firefox/.test(ua);
  const isDesktop = !isIos && !isAndroid;

  return {
    isIos,
    isAndroid,
    isFirefox,
    isDesktop,
    userAgent: ua,
  };
}

export type ManualPlatform =
  | "ios"
  | "firefox"
  | "android"
  | "desktop"
  | "other"
  | null;

/**
 * Which platform needs MANUAL install instructions?
 * (iOS Safari, Firefox, older browsers)
 */
export function manualInstallPlatform(): ManualPlatform {
  const { isIos, isFirefox, isAndroid, isDesktop } = detectPlatform();

  if (isIos) return "ios";
  if (isFirefox) return "firefox";
  if (isAndroid) return "android";
  if (isDesktop) return "desktop";
  return "other";
}
